<template>
    <v-form
        class="session-question-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
        <div class="d-flex justify-space-between flex-wrap align-start">
			<div style="width: 100%">
				<div class="session-question-form__field-label mb-2">Question</div>
				<v-textarea
					class="session-question-form__field-input pt-0 rounded"
					color="red"
					v-model="fields.text"
					:error-messages="field_errors.required"
					:rules="rules"
					required
					rows="3"
					placeholder="Your question here..."
				>
				</v-textarea>
				<p
					class="red--text text-center"
					v-for="error in errors"
					:key="error"
					style="width: 100%"
				>
					{{ error }}
				</p>
			</div>

            <div class="d-flex justify-center mt-10" style="width: 100%">
                <v-btn 
                    class="session-question-form__button session-question-form__buttonCancel elevation-0" 
                    outlined 
                    :disabled="isLoading"
                    @click="closeModal"
                >
                    Cancel
                </v-btn>

                <v-btn
                class="session-question-form__button session-question-form__buttonSave elevation-0"
                    :loading="isLoading"
                    :disabled="isLoading"
                    @click="validateAndSubmit"
                >
                    Save
                </v-btn>
            </div>
		</div>
    </v-form>
</template>

<script>
import { ruleRequired } from '@/utils/rules'
import Form from '@/mixins/Form'
import { mapActions, mapGetters } from 'vuex'
export default {
    mixins: [Form],
    props: {
        qaIsAutocomplete: {
            type: Boolean,
            default: false
        },
        isQuestionsPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fields: {
                text: '',
            },
        }
    },
    methods: {
        ...mapActions('event', ['addSessionQuestion', 'getSession', 'getSessionQuestions']),
        ...mapActions('app', ['showAlert', 'hideAlert']),

        async submitForm() {
            await this.addSessionQuestion({
                session_id: this.$route.params.sessionId,
                session_question_answer_text: this.fields.text
            })
        },
        closeModal() {
            this.$emit('closeModal')
            this.$refs.form.reset()
        }
    },
    computed: {
        ...mapGetters('event', ['eventErrors', 'isLoading']),

        rules() {
            return [
                (v) => ruleRequired(v) || 'Field is required.',
                (v) => (v && v.trim().length > 0) || 'Question cannot be blank.',
                (v) => (v && v.length <= 255) || 'Maximum 255 characters allowed.'
            ]
        }
    },
    watch: {
        isLoading(newValue, oldValue) {
            if (!newValue && oldValue) {
                !this.eventErrors.length && this.closeModal()
                const closeTimeout = setTimeout(() => {
                    this.hideAlert('')
                }, 3000)
                const message = !this.eventErrors.length ? 
                    this.qaIsAutocomplete ? 
                    'Your question has submitted successfully.' 
                    : 'Your question has been submitted. Once it has been approved it will appear on the list of questions.' 
                    : 'Something goes wrong. Try again late'
                this.showAlert({ message, closeTimeout, type: !this.eventErrors.length ? 'success' : 'error' })
                if (this.qaIsAutocomplete && !this.eventErrors.length) {
                    this.isQuestionsPage ? this.getSessionQuestions({sessionId: this.$route.params.sessionId, session: true}) : this.getSession(this.$route.params.sessionId)
                }
            }
        }
    }
}
</script>

<style lang="scss">
.session-question-form {
    &__field-label {
        color: #697583;
        font-size: 14px;
        line-height: 17.07px;
        letter-spacing: -0.34px;
        font-family: Montserrat, sans-serif;
    }

    &__field-input {
        textarea {
            border: 1px solid #E2E2E2;
            border-radius: 5px;
        }
    }

    &__button {
        border-width: 2px;
        border-radius: 8px;
        font-size: 16px !important;
        font-weight: 700;
        text-transform: capitalize;
        padding: 10px 38px !important;

        @media (max-width: 480px) {
            padding: 0 !important;
            flex-grow: 1;
        }
    }

    &__buttonCancel {
        color: var(--accent-color) !important;
		background: #fff !important;
        margin-right: 8px;
    }

    &__buttonSave {
        background: var(--accent-color) !important;
        margin-left: 8px;
    }
}
</style>